import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AddNewIngredientButton from './AddNewIngredientButton';
import { recipeSaveService } from '../../services/recipeSaveService';
import IngredientsListItem from './IngredientsListItem';
import RecipeIngredientNumberValue from "./RecipeIngredientNumberValue";
import { Input } from '@chapche/ui';
import {
    RECIPE_INGREDIENT_GROUP_ADDS,
    RECIPE_INGREDIENT_GROUP_BASE,
    RECIPE_INGREDIENT_GROUP_LIQUID,
} from '../../constant';

const RecipeIngredientGroupsTabContent = () => {
    const [searchParams] = useSearchParams();
    const { i18n } = useTranslation();
    const ingredientTab = searchParams.get('ingredientTab');
    const recipe = recipeSaveService.getRecipe();
    const showShare = ingredientTab === RECIPE_INGREDIENT_GROUP_BASE
        || ingredientTab === RECIPE_INGREDIENT_GROUP_ADDS;
    const showMinMax = ingredientTab !== RECIPE_INGREDIENT_GROUP_LIQUID;
    const shareValue = ingredientTab === RECIPE_INGREDIENT_GROUP_BASE
        ? (recipe.baseShare ?? 70)
        : (recipe.addsShare ?? 30);

    return (
        <>
            <AddNewIngredientButton />
            <div className="product__form-block recipe__ingredientGroup-edit">
                {showMinMax ? (
                    <>
                        <RecipeIngredientNumberValue
                            ingredientsGroup={ingredientTab}
                            ingredientsGroupNumber={'min'}
                            fieldValue={recipeSaveService.getIngredientGroupMinNumber(ingredientTab)} />
                        <RecipeIngredientNumberValue
                            ingredientsGroup={ingredientTab}
                            ingredientsGroupNumber={'max'}
                            fieldValue={recipeSaveService.getIngredientGroupMaxNumber(ingredientTab)} />
                    </>
                ) : (
                    <p className="block__content">{i18n.t('app.page.recipe.liquidHint')}</p>
                )}
                {showShare ? (
                    <label className="block__text product__form-label product__add-label">
                        <span className="product__form-number product__form-label_text">
                            {i18n.t('app.page.recipe.groupShare')}
                        </span>
                        <Input
                            fullWidth
                            className="mt-0"
                            type="number"
                            min={0}
                            max={100}
                            step={1}
                            value={shareValue}
                            onChange={(e) => recipeSaveService.updateGroupShare(ingredientTab, e.target.value)}
                        />
                    </label>
                ) : null}
            </div>
            <ul className="recipe__add-list">
                {recipe.ingredient && recipe.ingredient.length ?
                    recipe.ingredient.map(it => (
                        it.ingredientGroup === ingredientTab ?
                            <React.Fragment key={it.id}>
                                <IngredientsListItem ingredient={it} />  
                            </React.Fragment>
                            : 
                            null
                    ))
                    :
                    null
                }                      
            </ul>
        </>
        
    );
};

export default RecipeIngredientGroupsTabContent;
